export default {
  UTRUST_HOME: 'https://xmoney.com',
  TERMS_OF_SERVICE:
    'https://www.xmoney.com/legal/cryptoasset-terms-of-service---cifralfabeto-unipessoal-lda',
  PRIVACY_POLICY:
    'https://www.xmoney.com/legal/cryptoasset-privacy-policy---cifralfabeto-unipessoal-lda',
  OUR_POLICIES:
    'https://www.xmoney.com/legal/cryptoasset-terms-of-service---cifralfabeto-unipessoal-lda',
  support: {
    HOME: 'https://support.xmoney.com/en/',
    POLICIES_TERMS:
      'https://www.xmoney.com/legal/cryptoasset-terms-of-service---cifralfabeto-unipessoal-lda',
    PAYMENT_CONFIRMATION:
      'https://support.xmoney.com/en/articles/5828326-when-will-my-payment-be-confirmed',
    SUPPORTED_CURRENCIES_NETWORKS:
      'https://support.xmoney.com/en/articles/4879097-supported-currencies-and-networks',
    MERCHANT_ELIGIBILITY_AND_RESTRICTED_COUNTRIES:
      'https://support.xmoney.com/en/articles/4879553-merchants-is-xmoney-available-for-all-of-my-clients',
    REFUND_POLICY:
      'https://support.xmoney.com/en/articles/4388032-refund-amount',
    METHOD_OF_PAYMENTS:
      'https://support.xmoney.com/en/articles/7127618-method-of-payments',
    HOW_TO_PAY: 'https://support.xmoney.com/en/articles/4388047-how-to-pay',
    HOW_TO_PAY_FROM_WALLET:
      'https://support.xmoney.com/en/articles/9122444-how-to-pay-from-a-wallet',
    HOW_TO_PAY_FROM_EXCHANGE:
      'https://support.xmoney.com/en/articles/9122694-how-to-pay-from-an-exchange',
    HOW_TO_PAY_FROM_METAMASK:
      'https://support.xmoney.com/en/articles/9134614-how-to-pay-using-metamask',
    HOW_TO_PAY_FROM_XPORTAL:
      'https://support.xmoney.com/en/articles/9133435-how-to-pay-using-xportal',
    HOW_TO_PAY_FROM_MVX_DEFI_WALLET:
      'https://support.xmoney.com/en/articles/9134653-how-to-pay-using-multiversx-defi-wallet',
    HOW_TO_PAY_FROM_ANY_WALLET:
      'https://support.xmoney.com/en/articles/9155518-how-to-pay-from-any-wallet',
    HOW_TO_PAY_FROM_WALLETCONNECT:
      'https://support.xmoney.com/en/articles/8344450-wallet-connect',
    USDT_DEPRECATION:
      'https://support.xmoney.com/en/articles/10757983-buyers-info-usdt-payments-no-longer-supported-due-to-mica-regulations',
    TRAVEL_RULE:
      'https://support.xmoney.com/en/articles/11666696-what-is-the-travel-rule',
  },
  SOLANA_WALLETS:
    'https://docs.solanapay.com/#:~:text=to%20get%20started.-,Supporting%20Wallets,-Phantom%20(iOS',
  MVX_FIREFOX_ADDON_LINK:
    'https://addons.mozilla.org/en-US/firefox/addon/multiversx-defi-wallet',
  MVX_CHROME_EXTENSION_LINK:
    'https://chrome.google.com/webstore/detail/multiversx-defi-wallet/dngmlblcodfobpdpecaadgfbcggfjfnm',
  TRUSTPILOT_LINK: 'https://www.trustpilot.com/review/xmoney.com',
  getUserFeedbackFormLink: (uuid: string) =>
    `https://form.typeform.com/to/nfNzUjzZ#uuid=${uuid}`,
  getCurrencyNetworkSurveyLink: (uuid: string) =>
    `https://form.typeform.com/to/Z95VAL9B#uuid=${uuid}`,
};
